import React, { ElementType } from 'react';
import { DrawerContextProvider } from './DrawerContext';
import DrawerHeader from './DrawerHeader';
import { DrawerBody, DrawerFooter, DrawerTitle } from './DrawerContent';

interface DrawerProps {
  children: React.ReactNode;
  className?: string;
  as?: ElementType;
  id?: string;
  show?: any;
  onHide?: any;
}

const Drawer = ({ children, className, show, onHide, id, as: Component = "div", ...props }: DrawerProps) => {

  return (
    <React.Fragment>
      <DrawerContextProvider show={show} onHide={onHide}>
        <Component
          {...props} id={id ? id : ''} className={`${className ? className : ''}`}
        >
          {children}
        </Component>
      </DrawerContextProvider>
      <div onClick={onHide} className={`fixed inset-0 bg-slate-900/50 dark:bg-zink-800/80 z-[1049] backdrop-overlay backdrop-blur-sm transition-all duration-300 ease-in-out ${!show ? "opacity-0 pointer-events-none" : "opacity-100"}`} id="backDropDiv"></div>
    </React.Fragment>
  );
};

export default Object.assign(Drawer, {
  Header: DrawerHeader,
  Title: DrawerTitle,
  Body: DrawerBody,
  Footer: DrawerFooter
});
